export enum DonorPreselectStatus {    
    Declined = 0,
    Accepted = 1
}